import isEmpty from 'lodash-es/isEmpty';

export const buildDiscountableProductsFilter = (
  filterDiscountableProducts = false,
  discountableProductIds: (string | number)[]
) => {
  if (!isEmpty(discountableProductIds) && filterDiscountableProducts) {
    return `(${discountableProductIds
      .map((productId) => `product_id:${productId}`)
      .join(' OR ')})`;
  } else {
    return '';
  }
};
